module.exports = __webpack_public_path__ + "static/img/slide5.1dcf3aa8.jpg";